/**
 * Appends `auth_method` query param for GTM/GA login attribution (google | facebook | email).
 *
 * GTM setup (container GTM-W2VTTCGV):
 * 1. Variable: URL → Query → auth_method
 * 2. Trigger: Page View — Page URL matches RegEx auth_method=(google|facebook|email)
 * 3. GA4 tag: event login (or custom) with parameter auth_method = {{URL Query - auth_method}}
 *
 * Same pattern as ?plan= on /payment/success (see paymentSuccessContent.js).
 */
const ALLOWED = new Set(['google', 'facebook', 'email']);

export function parseAuthMethod(search) {
    if (typeof search !== 'string' || !search) {
        return null;
    }

    const query = search.startsWith('?') ? search.slice(1) : search;
    const value = new URLSearchParams(query).get('auth_method');

    return ALLOWED.has(value) ? value : null;
}

export function appendAuthMethod(path, method) {
    if (!ALLOWED.has(method)) {
        return path;
    }

    const qIndex = path.indexOf('?');
    const ampersand = path.indexOf('&');
    let pathname = path;
    let search = '';

    if (qIndex !== -1) {
        pathname = path.slice(0, qIndex);
        search = path.slice(qIndex + 1);
    } else if (ampersand !== -1) {
        pathname = path.slice(0, ampersand);
        search = path.slice(ampersand + 1);
    }

    const params = new URLSearchParams(search);
    params.set('auth_method', method);

    const serialized = params.toString();
    return serialized ? `${pathname}?${serialized}` : pathname;
}
